// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IG-z","hovered":"JG-z","hoverImage":"KG-z","mainImage":"LG-z","imageNoBackground":"MG-z","fullSizeImage":"NG-z"};